import { render, staticRenderFns } from "../cfdi/cfdi.html?vue&type=template&id=034955f2&scoped=true&external"
import script from "../cfdi/cfdi.js?vue&type=script&lang=js&external"
export * from "../cfdi/cfdi.js?vue&type=script&lang=js&external"
import style0 from "../cfdi/cfdi.css?vue&type=style&index=0&id=034955f2&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034955f2",
  null
  
)

export default component.exports